module.exports = {
  useSentry: false,
  useMixpanel: false,
  mixpanel: '71c519efc55a6bfcdde2414f315af656',
  apiUrl: 'https://chronos-api-proxy.web-pal.com/api', // server url
};
